export default __webpack_public_path__ + "static/tb_radler_03_EN-0c1a0d05d48ab111b17edd301e1c1c36.svg";